import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Avatar, Button, Col } from "antd";
import { useEffect } from "react";

import { useRecipesCategories, useTableRecipesCategories } from "../hook";
import Table from "../../../shared/components/ui/Table";
import { recipesCategoriesService } from "../../../shared/services";
import { DataRecipesCategory } from "../../../redux/@types/recipesCategories";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";

export const TableRecipesCategories = () => {
  const { changeRecipesCategoryForUpdate, showDeleteConfirm } =
    useTableRecipesCategories();
  const { setTableProps } = useRecipesCategories();

  const columns: TableColumns<DataRecipesCategory> = [
    {
      title: "Imagen",
      width: 7,
      dataIndex: "path_cover",
      key: "path_cover",
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-evenly",
            flexDirection: "row",
          }}
        >
          <Avatar
            size={64}
            src={
              item.path_cover
                ? `${PATH_S3_BUCKET}/${item.path_cover}`
                : undefined
            }
          />
        </Col>
      ),
    },
    {
      title: "Nombre",
      width: 10,
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Prioridad",
      width: 6,
      dataIndex: "priority",
      key: "priority",
    },
    {
      title: "Estado",
      width: 6,
      dataIndex: "status",
      key: "status",
      render: (_, item) => (item.status === "active" ? "Activo" : "Inactivo"),
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 6,
      render: (_, item) => (
        <Col
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-evenly",
            flexDirection: "row",
          }}
        >
          <Button
            type="primary"
            shape="circle"
            onClick={() => changeRecipesCategoryForUpdate(item)}
            icon={<EditOutlined />}
            size="large"
          />
          <Button
            type="primary"
            danger
            onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
            shape="circle"
            icon={<DeleteOutlined />}
            size="large"
          />
        </Col>
      ),
    },
  ];

  return (
    <Table<DataRecipesCategory>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={recipesCategoriesService}
      onLoad={setTableProps}
    />
  );
};
